<template>
    <div id="app" :class="$route.name">
        <b-navbar v-if="!loadingPage" :active.sync="menuopen" class="w-100">
            <template slot="brand">
                <div class="wrapper py-0 w-100 h-100">
                    <div class="container pr-0 h-100">
                        <div class="columns w-100 m-0 h-100 is-align-items-center">
                            <div class="column is-9-tablet p-y-0-tablet is-position-relative h-100 p-l-0-mobile p-t-5-mobile p-b-5-mobile p-0">
                                <div class="is-flex header-content is-align-items-center h-100">

                                    <b-navbar-item class="brand" tag="router-link" :to="{ path: !($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account') ? '/' : '/account' }">
                                        <span class="is-hidden-mobile">Pickafund</span>
                                        <span class="is-hidden-tablet is-flex is-align-items-left is-size-5">
                                            <span class="mobile-logo is-hidden-tablet title-pickafund">Pickafund</span>
                                        </span>
                                    </b-navbar-item>

                                    <div class="info-header p-0 w-100">
                                        <b-carousel v-if="isShowRollingMessage" class="is-hidden-mobile" :class="{'no-animation': !animationRollingMessage}" :autoplay="autoPlayMessage" :autoplaySpeed="3000" :interval="7000" :has-drag="false" :indicator="false" :pause-hover="false">
                                            <b-carousel-item v-if="rollingMessages.length > 0">
                                                <div class="rolling-message">
                                                    {{randomMessage.message}} 
                                                    <a class="text-decoration" :href="randomMessage.url">{{randomMessage.anchor}}</a>
                                                </div>
                                            </b-carousel-item>
                                            <b-carousel-item v-for="(item, i) in rollingMessages" :key="i">
                                                <div class="rolling-message">
                                                    {{item.message}} 
                                                    <a class="text-decoration" :href="item.url">{{item.anchor}}</a>
                                                </div>
                                            </b-carousel-item>
                                        </b-carousel>
                                        <ul class="is-hidden-mobile header-navbar" v-else>
                                            <li>SEARCH
                                            </li>
                                            <li>COMPARE</li>
                                            <li>INVEST</li>
                                        </ul>
                                    </div>
                                    <div class="is-hidden-tablet pl-2">
                                        <router-link v-if="$store.state.auth.authenticated" to="/account" style="right: 165px; top: 5px;" class="icon-link-profile">
                                            <span :class="showState" class="profile-bar ">
                                            <span class="text">Profile</span></span>
                                        </router-link>
                                        <a v-if="$store.state.auth.authenticated"  @click="menuopen=false,confirm()" class="icon-link logout is-hidden-mobile"><img src="/img/mb-Logout.svg"></a>
                                        <router-link v-else to="/login" class="btn btn-login btn-clear has-text-centered">LOGIN</router-link>
                                    </div>
                                </div>
                            </div>
                            <div class="column is-3-tablet is-hidden-mobile">
                                <div class="header-buttons-wrapper">
                                    <router-link v-if="$store.state.auth.authenticated" to="/account" class="btn link-header has-text-centered mr-4"><span :class="showState" class="profile-bar"><span class="text">Profile</span></span></router-link>
                                    <a v-if="$store.state.auth.authenticated"  @click="menuopen=false,confirm()" class="btn btn-clear has-text-centered">LOGOUT</a>
                                    <div v-else>
                                        <router-link to="/login" class="btn btn-clear has-text-centered">LOGIN</router-link>
                                        <router-link to="/pages/whats-new" class="btn-new btn btn-clear has-text-centered ml-2">WHAT'S NEW</router-link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>

            <template  slot="start">
                <div class="main-menu mobile">
                    <ul class="top-menu">
                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')"><router-link v-on:click.native="menuopen=false" to="/" exact><span class="icon"><img width="22px" height="22px" src="/img/search-icon.png"></span><span class="label">Search Funds</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon"><img width="22px" height="22px" src="/img/search-icon.png"></span><span class="label">Search Funds</span></a></li>

                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')" @click="$store.commit('auth/SET_HITTING_LIMIT', 'dashboard')"><router-link v-on:click.native="menuopen=false" to="/dashboard"><span class="icon about"><img src="/img/Dashboard-mobile.png" loading="lazy"></span><span class="label">My Dashboard</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon about"><img src="/img/Dashboard-mobile.png"></span><span class="label">My Dashboard</span></a></li>

                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')" @click="$store.commit('auth/SET_HITTING_LIMIT', 'watchlist')"><router-link v-on:click.native="menuopen=false" to="/watchlist"><span class="icon about"><img src="/img/mb-Watchlist.svg"></span><span class="label">My Watchlists</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon about"><img src="/img/mb-Watchlist.svg"></span><span class="label">My Watchlists</span></a></li>

                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')"><router-link v-on:click.native="menuopen=false" to="/about"><span class="icon about"><img src="/img/mb-About.svg"></span><span class="label">About us</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon about"><img src="/img/mb-About.svg"></span><span class="label">About us</span></a></li>
                        
                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')"><router-link v-on:click.native="menuopen=false" to="/faq"><span class="icon"><img src="/img/mb-FAQ.svg"></span><span class="label">FAQs</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon"><img src="/img/mb-FAQ.svg"></span><span class="label">FAQs</span></a></li>
                        
                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')"><router-link v-on:click.native="menuopen=false" to="/contact"><span class="icon"><img src="/img/mb-Contact.svg"></span><span class="label">Contact</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon"><img src="/img/mb-Contact.svg"></span><span class="label">Contact</span></a></li>
                        
                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')"><router-link v-on:click.native="menuopen=false" to="/blog"><span class="icon"><img src="/img/mb-Blog.svg"></span><span class="label">Blog</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon"><img src="/img/mb-Blog.svg"></span><span class="label">Blog</span></a></li>

                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')"><router-link v-on:click.native="menuopen=false" to="/fund-news-recap"><span class="icon"><img src="/img/mb-FAQ.svg"></span><span class="label">Fund News</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon"><img src="/img/mb-FAQ.svg"></span><span class="label">Fund News</span></a></li>

                        <li v-if="$store.state.auth.authenticated">
                            <a @click="menuopen=false,confirm()"  ><span class="icon"><img src="/img/Logout.svg"></span><span class="label">Logout</span></a>
                        </li>
                        <li v-else>
                            <router-link v-on:click.native="menuopen=false" to="/login"><span class="icon"><img src="/img/Login.svg"></span><span class="label">Login | Sign Up</span></router-link>
                        </li>
                    </ul>
                    <hr>
                    <!-- <ul class="bottom-menu">
                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')"><router-link v-on:click.native="menuopen=false" to="/about"><span class="icon about"><img src="/img/mb-About.svg"></span><span class="label">About us</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon about"><img src="/img/mb-About.svg"></span><span class="label">About us</span></a></li>
                        
                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')"><router-link v-on:click.native="menuopen=false" to="/faq"><span class="icon"><img src="/img/mb-FAQ.svg"></span><span class="label">FAQs</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon"><img src="/img/mb-FAQ.svg"></span><span class="label">FAQs</span></a></li>
                        
                        <li v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')"><router-link v-on:click.native="menuopen=false" to="/contact"><span class="icon"><img src="/img/mb-Contact.svg"></span><span class="label">Contact</span></router-link></li>
                        <li v-else><a @click="menuopen=false, checkValidate()"><span class="icon"><img src="/img/mb-Contact.svg"></span><span class="label">Contact</span></a></li>
                    </ul> -->
                </div>
            </template>


        </b-navbar>


            <div v-if="!isChangePasswordPage" class="sidebar-page">
                <section class="sidebar-layout">

                    <b-sidebar
                        :on-cancel="true"
                        :position="'fixed'"
                        :reduce="reduce"
                        :fullheight="true"
                        type="is-dark"
                        open
                    >
                        <div class="header-mobile-menu">
                            <button style="z-index: 1000; color: white" @click="reduce=!reduce" class="menu-toggler-button">
                                <b-icon v-if="reduce" size="is-large" icon="menu"></b-icon>
                                <b-icon v-else size="is-large" icon="close"></b-icon>
                            </button>
                            <b-navbar-item class="brand" tag="router-link" :to="{ path: '/' }">
                                Pickafund
                            </b-navbar-item>
                        </div>

                        <div class="main-menu">
                            <ul class="top-menu">
                                <li @click="showGlossary=false" v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')">
                                    <router-link to="/" :class="{ 'router-link-active': isSearch }" exact>
                                        <span class="icon" title="New search"><img width="22px" height="22px" src="/img/search-home.png" alt="New Search" loading="lazy"></span>
                                        <span class="label">Search Funds</span>
                                    </router-link>
                                </li>
                                <li v-else><a @click="checkValidate, showGlossary=false" :class="{ 'router-link-active': isSearch }"><span class="icon" title="New search"><img  width="22px" height="22px" src="/img/search-home.png" alt="New Search" loading="lazy"></span><span class="label">Search Funds</span></a></li>
                                
                                <!-- <li><a @click="soonModalActive1 = true"><span class="icon" title="My Dashboard"><img src="/img/Dashboard-new.png"></span><span class="label">My Dashboard</span></a></li>
                                <li><a @click="soonModalActive1 = true"><span class="icon" title="Alerts"><img src="/img/Alerts.svg"></span><span class="label">Alerts</span></a></li>
                                <li><a @click="soonModalActive1 = true"><span class="icon" title="Watchlists"><img src="/img/Watchlist.svg"></span><span class="label">Watchlists</span></a></li> -->

                                <template v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')">
                                    <li @click="$store.commit('auth/SET_HITTING_LIMIT', 'dashboard'), showGlossary=false"><router-link to="/dashboard"><span class="icon" title="My Dashboard"><img  width="22px" height="22px" src="/img/Dashboard-new.png" loading="lazy"></span><span class="label">My Dashboard</span></router-link></li>
                                    <li @click="$store.commit('auth/SET_HITTING_LIMIT', 'watchlist'), showGlossary=false"><router-link to="/watchlist"><span class="icon" title="My Watchlists"><img  width="22px" height="22px" src="/img/Watchlist.svg"></span><span class="label">My Watchlists</span></router-link></li>

                                    <li @click="showGlossary=false"><router-link to="/about"><span class="icon about" title="About us"><img  width="22px" height="22px" src="/img/About.svg" alt="About us"></span><span class="label">About us</span></router-link></li>
                                    <li @click="showGlossary=false"><router-link to="/faq"><span class="icon" title="FAQs"><img  width="22px" height="22px" src="/img/FAQ.svg" alt="FAQs"></span><span class="label">FAQs</span></router-link></li>
                                    <li @click="showGlossary=false"><router-link to="/contact"><span class="icon" title="Contact us"><img  width="22px" height="22px" src="/img/Contact.svg" alt="Contact us"></span><span class="label">Contact</span></router-link></li>
                                    <li @click="showGlossary=false"><router-link to="/blog">
                                        <span class="icon" title="Blog">
                                            <span v-if="reduce" >Blog</span>
                                            <img v-else  width="22px" height="22px" src="/img/Blog.svg" alt="Blog">
                                        </span>
                                        <span class="label">Blog</span></router-link>
                                    </li>
                                    <li><router-link to="/fund-news-recap"><span class="icon" title="Glossary">News</span><span class="label">Fund News</span></router-link></li>
                                    <li><a @click="$route.path !== '/pages/fund-investing-glossary' ? showGlossary = true : showGlossary = false "><span class="icon" title="Glossary">Glos</span><span class="label">Glossary</span></a></li>
                                </template>
                                <template v-else>
                                    <li @click="showGlossary=false"><a @click="checkValidate"><span class="icon about" title="About us"><img  width="22px" height="22px" src="/img/About.svg" alt="About us"></span><span class="label">About us</span></a></li>
                                    <li @click="showGlossary=false"><a @click="checkValidate"><span class="icon" title="FAQs"><img  width="22px" height="22px" src="/img/FAQ.svg" alt="FAQs"></span><span class="label">FAQs</span></a></li>
                                    <li @click="showGlossary=false"><a @click="checkValidate"><span class="icon" title="Contact us"><img  width="22px" height="22px" src="/img/Contact.svg" alt="Contact us"></span><span class="label">Contact</span></a></li>
                                    <li @click="showGlossary=false"><a @click="checkValidate"><span class="icon" title="Blog"><img  width="22px" height="22px" src="/img/Blog.svg" alt="Blog"></span><span class="label">Blog</span></a></li>
                                </template>

                                <li @click="showGlossary=false" class="is-hidden-tablet" v-if="$store.state.auth.authenticated">
                                    <a @click="menuopen=false,confirm()" class="button">LOGOUT</a>
                                </li>
                                <li @click="showGlossary=false" class="is-hidden-tablet" v-else>
                                    <router-link to="/login" class="button">LOGIN</router-link>
                                </li>                            
                            </ul>

                            <!-- <ul v-if="!($store.state.auth.profile < 1 && $router.currentRoute.fullPath === '/account')" class="bottom-menu">
                                <li><router-link to="/about"><span class="icon about" title="About us"><img src="/img/About.svg" alt="About us"></span><span class="label">About us</span></router-link></li>
                                <li><router-link to="/faq"><span class="icon" title="FAQs"><img src="/img/FAQ.svg" alt="FAQs"></span><span class="label">FAQs</span></router-link></li>
                                <li><router-link to="/contact"><span class="icon" title="Contact us"><img src="/img/Contact.svg" alt="Contact us"></span><span class="label">Contact</span></router-link></li>
                            </ul>
                            <ul v-else class="bottom-menu">
                                <li><a @click="checkValidate"><span class="icon about" title="About us"><img src="/img/About.svg" alt="About us"></span><span class="label">About us</span></a></li>
                                <li><a @click="checkValidate"><span class="icon" title="FAQs"><img src="/img/FAQ.svg" alt="FAQs"></span><span class="label">FAQs</span></a></li>
                                <li><a @click="checkValidate"><span class="icon" title="Contact us"><img src="/img/Contact.svg" alt="Contact us"></span><span class="label">Contact</span></a></li>
                            </ul> -->
                            
                        </div>

                    </b-sidebar>
                </section>
            </div>
            
            <cookie-law v-once theme="base" :buttonDecline="true" 
            :buttonText="'Accept'" class="Cookie--custom" 
            position="bottom" v-on:decline="checkCookieDisabled()"
            >
                

                <div slot-scope="props">
                    <div slot="message">
                        <p class="m-b-10-tablet is-hidden-mobile">We value your privacy, it is very important to us. We use cookies to help us keep our website safe and offer you the best experience online. By continuing, you agree to the use of our optional cookies. If you would like to know more about cookies, please view our <a @click="$router.push('/privacy')">privacy & cookie policy</a>.</p>
                        <p class="is-size-7-mobile m-b-10 is-hidden-tablet">We value your privacy, it is very important to us. <br><br>We use cookies to help us keep our website safe and offer you the best experience online. <br><br>By continuing, you agree to the use of our optional cookies. <br><br>If you would like to know more about cookies, please view our <a @click="$router.push('/privacy')">privacy & cookie policy</a>.</p>
                    </div>
                    <div class="is-flex is-justify-content-center">
                        <button id="acceptCookie" class="button is-primary mr-1" @click="props.accept"><span>Accept</span></button>
                        <button class="button is-primary ml-1" @click="props.close"><span>Decline</span></button>
                    </div>
                </div>
            </cookie-law>

            <div class="container is-max-tablet is-max-desktop is-max-fullhd">
                <router-view :key="$route.fullPath"/>
            </div>
            <template v-if="!loadingPage">
            <a href="javascript:" class="help-button" v-on:click="chatBot=true">HELP</a>
            <div v-show="chatBot" class="chat-bot-container">
                <div class="chat-bot-list">
                    <div class="chat-bot-item">Chat bot <span class="close-chat-bot modal-close" v-on:click="chatBot=false"></span></div>
                    <div class="chat-bot-item"><a href="/pages/whats-new">What's New</a> <span class="close-chat-bot modal-close" v-on:click="chatBot=false"></span></div>
                    <div class="chat-bot-item"><a href="javascript:void(0)" @click="openChatBot">Customer Assistant Bot</a></div>
                    <div class="chat-bot-item"><a href="/contact">Contact Form</a></div>
                    <div class="chat-bot-item"><a href="/faq">FAQs</a></div>
                    <div class="chat-bot-item" v-if="fltpagehelps.length" >
                        <div v-on:click="chatBotPageHelps=true, chatBotOtherUsefulRes=false">Page Helps</div>
                        <div v-show="chatBotPageHelps" class="chat-bot-container-sub">
                            <span class="close-chat-bot modal-close" v-on:click="chatBotPageHelps=false"></span>
                            <div class="chat-bot-item" v-for="(item, index) in fltpagehelps" :key="index"><a :href="item.url" target="_blank">{{ item.title }}</a></div>
                        </div>
                    </div>
                    <div class="chat-bot-item">
                        <div v-on:click="chatBotOtherUsefulRes=true, chatBotPageHelps=false">Useful Resources</div>
                        <div v-show="chatBotOtherUsefulRes" class="chat-bot-container-sub">
                            <span class="close-chat-bot modal-close" v-on:click="chatBotOtherUsefulRes=false"></span>
                            <div class="chat-bot-item"><a href="/pages/fund-investing-glossary">Glossary</a></div>
                            <div v-if="fltguides.length">
                                <div class="chat-bot-title">Guides</div>
                                <div class="chat-bot-item" v-for="(item, index) in fltguides" :key="index"><a :href="item.url" target="_blank">{{ item.title }}</a></div>
                            </div>
                            <div v-if="fltvideos.length">
                                <div class="chat-bot-title">Video Tutorials</div>
                                <div class="chat-bot-item" v-for="(item, index) in fltvideos" :key="index"><a :href="item.url" target="_blank">{{ item.title }}</a></div>
                            </div>
                            <div v-if="fltotherusefulres.length">
                                <div class="chat-bot-title">Tools & Insights</div>
                                <div class="chat-bot-item" v-for="(item, index) in fltotherusefulres" :key="index"><a :href="item.url" target="_blank">{{ item.title }}</a></div>
                            </div>
                            <div v-if="fromPartners.length">
                                <div class="chat-bot-title">Press, Media & Socials</div>
                                <div class="chat-bot-item" v-for="(item, index) in fromPartners" :key="index"><a :href="item.url" target="_blank">{{ item.title }}</a></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <a v-show="isShowScrollToTop" v-scroll-to="{ el: 'body', duration: 500, }" class="scroll-to-top"><img width="48px" height="31px" src="/img/up.svg" ></a>
            <footer v-if="!loadingPage" class="footer p-b-10-tablet">
                <div class="container p-l-0-mobile p-r-0-mobile is-flex is-flex-direction-row is-flex-wrap-wrap is-max-tablet is-max-desktop is-max-fullhd">
                    <ul class="footer-links mb-0 is-flex is-justify-content-space-between mb-3 m-b-0-tablet is-align-items-center">
                        <li><router-link class="m-r-20-tablet" to="/privacy"><span>Privacy policy</span></router-link></li>
                        <li><router-link class="m-r-20-tablet" to="/page/61"><span>Terms of Service</span></router-link></li>
                        <li><router-link class="m-r-20-tablet" to="/about"><span>About Us</span></router-link></li>
                        <li><router-link class="m-r-20-tablet" to="/contact"><span>Contact Us</span></router-link></li>
                        <li><router-link class="m-r-20-tablet" to="/faq"><span>FAQs</span></router-link></li>
                        <li class="m-r-20-tablet"><a @click="carrerModalActive = true" >Careers</a></li>
                        <li><router-link class="m-r-20-tablet" to="/blog"><span>Blog</span></router-link></li>
                    </ul>
                    <div>
                        <ul class="social-links mb-0 is-flex is-justify-content-flex-end">
                            <li><a href="https://www.linkedin.com/company/pickafund/" target="_blank"><img style="width:20px" src="/img/linkedin.svg" class="mr-1"></a></li>
                            <li class="ml-3"><a href="https://twitter.com/pickafund" target="_blank"><img style="width:20px" src="/img/twitterX.svg" class="mr-1"></a></li>
                            <li class="ml-3"><a href="https://www.facebook.com/Pickafund-113861473823152" target="_blank"><img style="width:10px" src="/img/facebook.svg" class="mr-1"></a></li>
                            <li class="ml-3"><a href="https://youtube.com/@pickafund" target="_blank"><img style="width:24px" src="/img/youtube.svg" class="mr-1"></a></li>
                        </ul>
                    </div>
                </div>
                <div class="extra-link">
                    <ul>
                        <label class="extra-link-label">Guides</label>
                        <li v-for="(guide, index) in fltguides" :key="index">
                            <a :href="guide.url">{{ guide.title }}</a>
                        </li>
                    </ul>
                    <ul>
                        <label class="extra-link-label">Other Useful Resources</label>
                        <li><a href="/pages/fund-investing-glossary">Glossary</a></li>
                        <li v-for="(guide, index) in fltotherusefulres" :key="index">
                            <a :href="guide.url">{{ guide.title }}</a>
                        </li>
                    </ul>
                    <ul style="min-width: fit-content">
                        <label class="extra-link-label">Videos</label>
                        <li v-for="(video, index) in fltvideos" :key="index">
                            <a :href="video.url" target="_blank">{{ video.title }}</a>
                        </li>
                    </ul>
                </div>
                <div class="color-blue has-text-centered pt-5 line-height-medium is-size-7">
                    <p>Copyright © 2021 LONGANY LTD, PICKAFUND ® is a registered trademark. All rights reserved.</p>
                    <p>Registered address: 71-75 Shelton Street, Covent Garden, London, WC2H 9JQ</p>
                </div>

            </footer>
            <Feedback />
            </template>

            <b-modal
                v-model="carrerModalActive"
                has-modal-card
                trap-focus
                :destroy-on-hide="false"
                aria-role="dialog"
                aria-label="Example Modal"
                aria-modal>
                <template >
                    <div class="modal-card" style="width: auto;">
                        <section class="modal-card-body py-5 px-6">
                            <button
                                type="button"
                                class="delete"
                                @click="carrerModalActive=false"/>
                            <h3 class="has-text-centered">We are hiring soon.<br><span style="font-size: .8em; color: #999;">Sign up to hear about all our updates!</span></h3>
                        </section>
                    </div>
                </template>
            </b-modal>

            <b-modal
                v-model="mustLogin"
                has-modal-card
                trap-focus
                :destroy-on-hide="false"
                aria-role="dialog"
                aria-label="Example Modal"
                aria-modal>
                <template >
                    <div class="modal-card" style="width: auto">
                        <header class="modal-card-head">
                            <p class="modal-card-title mb-2">Login</p>
                            <p class="font-weight-400">To track funds on our <strong>unique</strong> Watchlists!</p>
                            <button
                                type="button"
                                class="delete"
                                @click="mustLogin=false"/>
                        </header>
                        <section class="modal-card-body">
                            <login-simple></login-simple>
                        </section>
                    </div>
                </template>
            </b-modal>


            <b-modal
                v-model="soonModalActive1"
                has-modal-card
                trap-focus
                :destroy-on-hide="false"
                aria-role="dialog"
                aria-label="Example Modal"
                aria-modal>
                <template >
                    <div class="modal-card" style="width: auto">
                        <section class="modal-card-body py-5 px-6">
                            <button
                                type="button"
                                class="delete"
                                @click="soonModalActive1=false"/>
                            <h2 class="has-text-centered dark-text has-text-weight-bold is-uppercase mb-1">{{$store.state.messages.modalContent}}</h2>
                            <h3 class="has-text-centered dark-text mb-2">Coming soon!</h3>
                            <div class="has-text-centered" v-if="$store.state.messages.modalContent!='blog'">
                                <p class="line-height-medium">This feature will be part of our next release</p>
                            </div>
                        </section>
                    </div>
            </template>
        </b-modal>

        <b-modal
            v-model="showFirstLogin"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Example Modal"
            aria-modal>
            <template >
                <div class="modal-card" style="width: auto">
                    <section  class="modal-card-body py-5 px-6">
                        <button
                            type="button"
                            class="delete"
                            @click="showFirstLogin=false"/>
                        <h3>As a registered user you can:</h3>
                        <ul class="guide-list">
                            <li>Create <strong>watchlists</strong> and add your favourite funds (by clicking on 
                                <span class="icon" title="My Watchlists"><img  width="22px" height="22px" src="/img/Watchlist.svg"></span>
                            )</li>
                            <li>Place <strong>alerts</strong> on funds (by clicking on 
                                <span class="icon icon-bell" title="Alerts"><img  width="22px" height="22px" src="/img/bell.svg"></span>
                            )</li>
                            <li>Access the  <strong>dashboard</strong>, your user homepage (by clicking on 
                                <span class="icon" title="My Dashboard"><img  width="22px" height="22px" src="/img/Dashboard-new.png" loading="lazy"></span>
                            )</li>
                        </ul>
                    </section>
                </div>
            </template>
        </b-modal>
        <b-modal
            v-model="showGlossary"
            has-modal-card
            trap-focus
            :destroy-on-hide="false"
            aria-role="dialog"
            aria-label="Example Modal"
            class="modal-glossary"
            hide-header-close="false"
            aria-modal>
            <template >
                <Glossary />
                <button type="button" class="modal-close is-large" @click="showGlossary=false"></button>
            </template>
        </b-modal>
    </div>
</template>

<script>
import axios from "axios";
import CookieLaw from 'vue-cookie-law'
import LoginSimple from "@/components/LoginSimple"
import Feedback from "@/components/Feedback"
import { config } from './config'
import Glossary from "@/components/Glossary"

export default {
    name: 'app',
    components: {
        CookieLaw,
        LoginSimple,
        Feedback,
        Glossary
    },
    data(){
        return {
            showGlossary: false,
            randomMessage: {},
            chatBot: false,
            chatBotGuides: false, 
            chatBotVideos: false, 
            chatBotPageHelps: false, 
            chatBotOtherUsefulRes:false,
            fltguides: [], 
            fltvideos: [], 
            fltpagehelps: [], 
            fltotherusefulres:[],
            profile: [],
            soonModalActive1:false,
            menuopen:false,
            showmessage:false,
            reduce:true,
            mustLogin:false,
            carrerModalActive: false,
            loadingPage: false,
            showFirstLogin: false,
            rollingMessages: [],
            isShowRollingMessage: true,
            animationRollingMessage: false,
            isShowScrollToTop: false,
            autoPlayMessage: true,
            fromPartners: [],
        }
    },
    methods:{
        confirm() {
            this.$buefy.dialog.confirm({
                class: 'prueba',
                type: 'is-danger',
                hasIcon: true,
                message: 'You are about to logout!',
                onConfirm: () => {
                    this.$store.commit("watchlist/SET_CURRENT_WATCHLIST", {})
                    this.$store.commit("auth/SET_PROFILE", null);
                    this.$router.push("/logout"); 
                }
            })
        },
        checkCookieDisabled() {
            window[`ga-disable-${config.idAnalytics}`] = true;
        },
        checkValidate() {
            this.$store.commit("auth/SET_VALIDATE", !this.$store.state.auth.isValidateField)
        },
        isMobile() {
            if (screen.width <= 760) {
               return true
            } else {
                return false
            }
        },
        getHelOption(option){
            axios(`/help-options-information/${option}`).then(res => {
                this[option] = res.data;
            })
        },
        getRollingMessages() {
            axios.get('/rolling-messages').then(res => {
                if (res && res.data) {
                    var randomNumber = Math.floor(Math.random() * res.data.length);
                    this.randomMessage = res.data[randomNumber];
                    this.rollingMessages = res.data.filter((word, index) => index != randomNumber);
                    var self = this;
                    setTimeout(function(){
                        self.animationRollingMessage = true;
                    }, 1500)
                }
            })
        },
        toggleRollingMessage(status) {
            this.isShowRollingMessage = status || !this.isShowRollingMessage;
        },
        openChatBot(){
            document.querySelector('#chatbase-bubble-button').click()
        }
    },
    computed:{
        isSearch(){
            const n  = this.$route.name
            if(n == "Home" || n == "Results" || n == "Detailedview Results"){
                return true
            }
            return false
        },
        showState(){
            if(this.$store.state.auth.profile == 2){
                return "full"
            }
            else if(this.$store.state.auth.profile == 1){
                return "medium"
            }
            return "no.prof"
        },
        isChangePasswordPage () {
            let currentPage = this.$route.name
            return (currentPage === 'ChangePassword')
        }
    },
    created() {
        const storage = JSON.parse(localStorage.getItem('cookie:accepted'));
        if(storage === false) {
            this.checkCookieDisabled();
        }
        this.$bus.$on('loadingPage', val =>{
            this.loadingPage = val
        })
        this.$router.beforeEach(async (to, from, next) => {
            if(to.path == '/login' || to.path == '/login/max-5') {
                next()
            } else {
                this.$store.commit('auth/SET_PREVIOUS_PAGE', to.path)
                next()
            }
            
         })
        axios(`/frompartners/asc/-1`).then(res => {
            this.fromPartners = res.data;
        })
        this.getHelOption('fltguides')
        this.getHelOption('fltvideos')
        this.getHelOption('fltpagehelps')
        this.getHelOption('fltotherusefulres')
        this.getRollingMessages();
    },
    mounted() {
        let self = this;
        window.addEventListener('scroll', () => {
            const chatBubbleBtn = document.querySelector('#chatbase-bubble-button');
            if (!chatBubbleBtn) return;
            if (window.scrollY) {
                self.isShowScrollToTop = true;
                chatBubbleBtn.style.bottom = "70px";
            } else {
                self.isShowScrollToTop = false;
                chatBubbleBtn.style.bottom = "20px";
            }
        })
        document.querySelector('.carousel').addEventListener('click', (event) => {
            let className = event.target.classList;
            if (className.contains('has-icons-right') || className.contains('mdi-chevron-right') || className.contains('mdi-chevron-left')|| className.contains('has-icons-left')) {
                self.autoPlayMessage = false;
            }
        });
        if (!['Login', 'Profile'].includes(this.$route.name)) {
            this.$store.commit("vsPage/SET_PREVIOUS_PAGE", ['ActivePassive', 'ESGvsNonESG', 'ITOpenEnded'].includes(this.$route.name) ? this.$route.path : '');
        }
    },
    watch: {
        '$store.state.messages.hash': function () {
            this.$buefy.toast.open({
                message: this.$store.state.messages.content,
                type: this.$store.state.messages.color,
                position: "is-top",
                duration: 6000,
            })
        },
        '$store.state.messages.modalHash': function () {
            this.soonModalActive1 = true
        },
        '$route' () {
            this.menuopen = false;
            if (!['Login', 'Profile'].includes(this.$route.name)) {
                this.$store.commit("vsPage/SET_PREVIOUS_PAGE", ['ActivePassive', 'ESGvsNonESG', 'ITOpenEnded'].includes(this.$route.name) ? this.$route.path : '');
            }
        },
        '$store.state.auth.mustLogin': function (data) {
            if(data==false){
                this.mustLogin=false
            }
            else{
                this.mustLogin=true
            }
        },
        '$store.state.auth.emailUser': function (data) {
            if (data && this.$store.state.auth.authenticated) {
                let emails = this.$cookies.get('skip-first-login-popup');
                if (emails) {
                    if (!emails.includes(data)) {
                        this.showFirstLogin = true;
                        emails.push(data)
                        this.$cookies.set('skip-first-login-popup', JSON.stringify(emails));
                    }
                } else {
                    this.showFirstLogin = true;
                    emails = [data]
                    this.$cookies.set('skip-first-login-popup', JSON.stringify(emails));
                }
            }
        },
        loadingPage: function(value) {
            if (value) {
                this.animationRollingMessage = false;
            } else {
                var self = this;
                setTimeout(function(){
                    self.animationRollingMessage = true;
                }, 1500)
            }
            
        },
        isShowScrollToTop: function(value){
            if (value) {
                document.body.classList.add('is-scroll-top')
            } else {
                document.body.classList.remove('is-scroll-top')
            }
        }
    },
}
</script>


<style scoped lang="scss">
.btn-new {
    white-space: nowrap;
    border-width: 4px;
    font-weight: bold;
    padding: 0.35em 1em !important;
}
.carousel-items .carousel-item {
  transition: -webkit-transform 1.5s ease;
  transition: transform 1.5s ease;
  transition: transform 1.5s ease, -webkit-transform 1.5s ease;
}

.no-animation .carousel-items .carousel-item {
  transition: none !important;
}

ul.guide-list {
    list-style-type: disc;

    li {
        margin: 10px 20px;
        line-height: 1.35em;

        .icon {
            background: #4192EA;
            width: 36px;
            line-height: 1.35rem;
            vertical-align: middle;
            border-radius: 4px;
            
            &.icon-bell {
                background: #EF5151;
            }

            img {
                width: 22px;
            }
        }
    }
}
.chat-bot-container {
    width: fit-content;
    background: #fff;
    position: fixed;
    bottom: 55px;
    left: 100px;
    border: 1px solid #000;
    z-index: 999;
}
@media (max-width: 767px) {
    .chat-bot-container {
        left: 20px;
        bottom: 60px;
        font-size: 14px;
    }
}
.chat-bot-container .chat-bot-item {
    padding: 4px 0;
    cursor: pointer;
}
.chat-bot-container .chat-bot-list {
    position: relative;
}
.chat-bot-container > div > div > a {
    color: #153647;
    padding: 5px 10px;
    display: block;
}
.chat-bot-container > div > div:first-child {
    background-color: yellow;
    display: none;
}
.chat-bot-container > div > div > div:first-child {
    padding: 5px 10px;
}
.chat-bot-container > div > div:not(:last-child) {
    border-bottom: 1px solid #000;
}
.close-chat-bot {
    position: absolute;
    right: 4px;
    top: 4px;
}
.close-chat-bot:before, 
.close-chat-bot:after,
.close-rolling-message:before,
.close-rolling-message:after {
    background-color: #153647;
}
.chat-bot-container-sub {
    position: absolute;
    left: calc(100% + 10px);
    top: 0;
    background-color: #fff;
    width: max-content;
    border: 1px solid #000;
    padding: 0;
    padding-right: 20px;
    max-width: calc(100vw - 100% - 160px);
    max-height: 100%;
    overflow-y: auto;
}
.chat-bot-container-sub a {
    text-decoration: underline;
    padding: 5px 10px;
    display: block;
}
.chat-bot-container-sub .close-chat-bot {
    top: 4px;
}
.carousel {
    min-height: auto;
    display: flex;
    justify-content: center;
    &-items &-item {
        display: flex;
        justify-content: center;
    }
}
.rolling-message {
    position: relative;
    padding: 9px 20px;
    font-weight: bold;
    color: #000;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: 100%;
}
.rolling-message a {
    text-decoration: underline;
}
.close-rolling-message {
    color: #000;
    position: absolute;
    right: 2px;
    top: 50%;
    transform: translateY(-50%);
}
.info-header ul.header-navbar {
    width: 100%;
    display: flex;
    justify-content: center;
}
.extra-link {
    color: #0070c0;
    font-size: 14px;
    font-weight: bold;
    margin-top: 27px;
    display: flex;
    justify-content: center;
    gap: 50px;
    &-label {
        color: #000;
    }

    & ul li:first {
        margin-top: 2px;
    }

    & ul li {
        margin-bottom: 5px;
        margin-top: 5px;
    }
}
@media (max-width: 767px) {
    .modal-close {
        &::before {
            width: 60%;
        }
        &::after {
            height: 60%;
        }
    }
    .close-chat-bot {
        top: 3.5px;
    }
    .extra-link {
        flex-direction: column;
        align-items: center;
        gap: 27px;
        ul {
            text-align: center;
        }
        a {
            width: 100%;
            display: inline-block;
            text-align: center;
        }
    }
    .chat-bot-container-sub {
        padding-right: 20px;
        max-width: calc(100vw - 100% - 35px);
    }
    .chat-bot-container .chat-bot-item {
        padding: 3px 5px;
    }
}
::v-deep .carousel-arrow .icon.has-icons-left {
    left: 0;
}
::v-deep .carousel .carousel-arrow {
    opacity: 1;
}
::v-deep .mdi-24px.mdi:before {
    color: #000;
    margin: 0;
}
::v-deep .carousel-arrow .icon {
    background-color: transparent;
    border: none;
}
::v-deep .carousel-arrow .icon.has-icons-right {
    right: 0;
}
::v-deep .carousel .carousel-items  {
    width: calc(100% - 125px);
    margin-left: 125px;
    background-color: #b9ede8;
    border-radius: 5px;
    max-width: 70%;
}
::v-deep .carousel-arrow .icon:hover {
    border: none
}
.chat-bot-title {
    font-weight: bold;
    padding: 0 10px;
    margin-top: 16px;
}
.modal-glossary ::v-deep  .animation-content {
    max-width: 100% !important;
    margin: 0;
}
.modal-glossary ::v-deep .modal-close::before, 
.modal-glossary ::v-deep .modal-close::after {
    background-color: #000;
}
.header-mobile-menu {
    display: flex;
}
.header-mobile-menu {
    display: flex;
    margin-bottom: 1.25rem;
}
</style>

